import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import UploadFilename from '../UploadFilename/UploadFilename';
import styled from 'styled-components';

interface Props extends GridCellProps {}

const FileUploadCell: React.FC<Props> = (props) => {
  //const field = props.field || '';
  const field = 'file_upload';
  const value: FileUpload = props.dataItem[field] || '';

  return (
    <td
      colSpan={props.colSpan}
      className={props.className}
      role="gridcell"
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      style={props.style}
    >
      {value ? <StyledUploadFilename filename_original={value.filename_original} path={value.path} /> : undefined}
    </td>
  );
};

const StyledUploadFilename = styled(UploadFilename)`
  display: flex;
  align-items: flex-start;
`;

export default FileUploadCell;
